<template>
	<div>
		<v-parallax
			src="https://image.shutterstock.com/z/stock-photo-optometry-concept-female-optometrist-optician-doctor-examines-eyesight-of-child-boy-in-eye-261198167.jpg"
		>
			<v-hover>
				<v-container
					slot-scope="{ hover }"
					class="my-4 fill-height"
					style="background:rgba(255,255,255,0.5); border-radius: 50px"
				>
					<v-row align-content="center" align="center" class="black--text" style="width: 100%" dense>
						<v-col cols="12" class="text-center">
							<v-img :src="require('../assets/logo.png')" contain height="96"></v-img>
						</v-col>
						<v-col cols="12" class="pt-6 pb-12 text-center">
							<h1 :class="$vuetify.breakpoint.mdAndUp ? 'display-2' : 'display-1'">
								<span>
									<strong class="primary--text">{{ tele }}</strong>
									{{ retina }}:
									{{ slogan }}
								</span>
							</h1>
						</v-col>
						<v-col cols="12">
							<div class="headline font-weight-regular text-center">
								<div
									:class="{'display-2': $vuetify.breakpoint.mdAndUp, 'display-1': !$vuetify.breakpoint.mdAndUp,'secondary--text':hover}"
								>
									<strong>3,852,000</strong>
								</div>
								<div v-if="arabic">
									مريضاً مصاب
									<span :class="{'primary--text': hover}">
										<strong>بالسكري</strong>
									</span> في السعودية
								</div>
								<div v-else>
									PATIENTS WITH
									<span :class="{'primary--text': hover}">
										<strong>DIABETES</strong>
									</span> IN SAUDI
								</div>
							</div>
						</v-col>
					</v-row>
				</v-container>
			</v-hover>
		</v-parallax>

		<v-card class="grey lighten-5 py-6" tile flat>
			<v-container>
				<v-row no-gutters>
					<v-col cols="12">
						<div class="headline primary--text font-weight-black">
							<v-icon color="primary" right size="30">mdi-account-question</v-icon>من نحن
						</div>
					</v-col>
					<v-col cols="12" class="subtitle-1 pt-6">
						شركة صحة سهلة الطبية
						شركة مسجلة بالمملكة العربية السعودية.
						أحد الشركات المحتضنة بادر وتتخذ من بادر للتقنية الحيوية بمدية الملك فهد الطبية بمدينة الرياض مقرا لها.
						تأسست في شهر شعبان من عام 1440هـ الموافق لمايو 2019م.
					</v-col>
				</v-row>
			</v-container>
		</v-card>

		<v-card class="grey lighten-4 py-6" tile flat>
			<v-container>
				<v-row no-gutters>
					<v-col cols="12">
						<div class="headline primary--text font-weight-black">
							<v-icon color="primary" right size="30">mdi-book-open-variant</v-icon>قصتنا
						</div>
					</v-col>
					<v-col cols="12" class="subtitle-1 pt-6">
						نحن في تلي رتنا (مشروع فحص الشبكية عن بعد) نسعى لتحقيق هدف واضح المعالم وهو القضاء على العمى الناتج عن اعتلال الشبكية السكري.
						وذلك من خلال الفحص الدوري لشبكية العين باستخدام كاميرات متخصصة وربطها بمنصة مركز قراءة الصور الافتراضي والذي يقوم عليه أخصائيو الشبكية بمساعدة تقنية الذكاء الاصطناعي مع تطبيق معايير جودة عالمية.
						تتوزع هذه الكاميرات في مراكز السكر او المراكز الصحية الأولية لتغطي مرضى السكر في منطقة محددة.
					</v-col>
				</v-row>
			</v-container>
		</v-card>

		<v-card class="grey lighten-5 py-12" tile flat>
			<v-container>
				<v-row class="text-center" justify="center" dense>
					<v-col cols="12" md="6" lg="4">
						<v-container class="pa-6 grey lighten-4 round fill-height">
							<v-hover>
								<v-row slot-scope="{ hover }" class="text-center" align="center">
									<v-col cols="5" sm="6" lg="4">
										<v-icon large class="primary--text" :class="{'secondary--text': hover}">mdi-information</v-icon>
										<div
											class="headline pt-2 pb-2 primary--text font-weight-bold"
											:class="{'secondary--text': hover}"
										>
											<template>{{ about_us }}</template>
										</div>
									</v-col>
									<v-col class="body-2" cols="7" sm="6" lg="8">
										<template>نحن فريق من الشباب السعودي الطموح من تقنين وأطباء حيث استشعرنا حجم وخطر مشكلة اعتلال الشبكية السكري من خلال قصص كثيرة لمرضى فقدوا نعمة البصر بسبب اعتلال الشبكية السكري فأصبحت هذه القصص دافعا لتقديم هذه الخدمة.</template>
									</v-col>
								</v-row>
							</v-hover>
						</v-container>
					</v-col>

					<v-col cols="12" md="6" lg="4">
						<v-hover>
							<v-container
								slot-scope="{ hover }"
								class="pa-6 grey lighten-4 round fill-height"
								:class="{'elevation-4': hover}"
							>
								<v-row class="text-center" align="center">
									<v-col cols="5" sm="6" lg="4" order="2" order-md="1">
										<v-icon large class="primary--text">mdi-eye</v-icon>
										<div class="headline pt-2 pb-2 primary--text font-weight-bold">{{ vision }}</div>
									</v-col>
									<v-col class="body-2" cols="7" sm="6" lg="8" order="1" order-md="2">
										القضاء على الحالات المتقدمة من اعتلال
										<strong>الشبكية السكري</strong> خلال خمس سنوات من خلال الوصول إلى مرضى السكر
										<strong>المسجلين</strong> بالمملكة. وهذا ما ينسجم مع الأهداف الاستراتيجية في نموذج التحول الوطني الصحي من تسهيل وصول المرضى للخدمة وتحسين الجودة والكفاءة للمنظومة الصحية.
									</v-col>
								</v-row>
							</v-container>
						</v-hover>
					</v-col>

					<v-col cols="12" md="12" lg="4">
						<v-hover>
							<v-container slot-scope="{ hover }" class="pa-6 grey lighten-4 round fill-height">
								<v-row class="text-center" align="center">
									<v-col cols="5" sm="6" lg="4" order="1" order-md="2" order-lg="1">
										<v-icon large class="primary--text" :class="{'scaling': hover}" @click="openContactUs">
											<template>mdi-email-plus</template>
										</v-icon>
									</v-col>

									<v-col cols="7" sm="6" lg="8" order="2" order-md="1" order-lg="2">
										<v-btn color="primary text-none" rounded large @click="openContactUs">تواصل معنا</v-btn>
									</v-col>
								</v-row>
							</v-container>
						</v-hover>
					</v-col>

					<v-col v-if="false" class="mt-2" cols="12">
						<v-container class="pa-0 py-12" style="border: 1px dashed grey">
							<div class="headline font-weight-bold">Advertisement Panel</div>
						</v-container>
					</v-col>
				</v-row>
			</v-container>
		</v-card>

		<v-card class="grey lighten-4 py-6" tile flat>
			<v-container>
				<v-row dense>
					<v-col cols="12">
						<div class="headline primary--text font-weight-black">
							<v-icon color="primary" right size="30">mdi-eye-off</v-icon>لماذا اعتلال الشبكية السكري؟
						</div>
					</v-col>
					<v-col cols="12" class="subtitle-1 pt-6">
						<div>تكمن أهمية مشكلة اعتلال الشبكية لأمرين:</div>
						<ul class="no-list">
							<li>
								الأول: زيادة المرضى المصابين بمرض السكر بالمملكة
								حيث يقدر عدد المصابين بالمرض قرابة
								<strong>4 مليون شخص</strong>.
							</li>
							<li>الثاني: أن تأثر الشبكية قد يصل الى مراحل متقدمة مما يؤدي إلى العمى دون أن يلاحظه المريض في وقت مبكر.</li>
						</ul>
						<div>
							<strong>فتاتي</strong> فكرة الفحص المبكر لاكتشاف هذه الحالات في وقت مناسب مما يتيح فرصة للعلاج وتفادي العمى لا قدر الله.
						</div>
					</v-col>
				</v-row>
			</v-container>
		</v-card>

		<v-card class="grey lighten-5 py-6" tile flat>
			<v-container>
				<v-row no-gutters>
					<v-col cols="12">
						<div class="headline primary--text font-weight-black">
							<v-icon color="primary" right size="30">mdi-account-group-outline</v-icon>الوضع الراهن:
						</div>
					</v-col>
					<v-col cols="12" class="subtitle-1 pt-6">
						<div>
							كما تشير الدراسات التي أجريت على مرضى السكر بالمملكة الى وجود
							<strong>شخص واحد من كل ثلاثة</strong> اشخاص يعاني من اعتلال الشبكية الناتج عن السكري وواحد من كل عشرة اشخاص في مرحلة متقدمة من المرض وقد يحتاج الى علاج.
						</div>
						<br />
						<div>لذلك توصي الجمعيات الطبية العالمية بإجراء فحص العين لكل مرضى السكر مرة كل سنة.</div>
						<br />
						<div>للأسف نسبة المرضى اللذين يلتزمون بهذا الاجراء تتراوح بين 15 و20 % من مرضى السكر فقط، مما يعني ان غالبية المرضى قد يكون عرضة لفقد النظر بسبب مرض السكر.</div>
						<br />
						<div>ان عدم التزام المرضى بالمتابعة الدورية لفحص قاع العين (الشبكية) يرجع الى عدة السباب أهمها: ان اجراء الفحص لقاع العين يحتاج الى متابعة من الطبيب المعالج و المريض لعمل الفحص الدوري غير انه يتوجب على المريض زيارة طبيب العيون عن طريق اخذ موعد والحضور وعمل الفحص مما قد يستغرق وقتا مهما من المريض الذي قد يكون لا يعاني من أي مشكلة بالفعل. فطول الإجراءات وعدم تنبيه المريض لفحص قاع العين يقف عائق لعمل الفحص الدوري.</div>
					</v-col>
				</v-row>
			</v-container>
		</v-card>

		<v-card class="grey lighten-4 py-6" tile flat>
			<v-container>
				<v-row no-gutters>
					<v-col cols="12">
						<div class="headline primary--text font-weight-black">
							<v-icon color="primary" right size="30">mdi-alpha-t-box</v-icon>لماذا تلي رتنا؟
						</div>
					</v-col>
					<v-col cols="12" class="subtitle-1 pt-6">
						<div>تدفعنا حاجة مرضى السكر لتقليل الحواجز التي تحول دون وصول الرعاية اللازمة لمرضى السكر ومتابعة تأثير المرض على الشبكية، وخاصة في المناطق النائية التي تعاني من نقص الخدمات. حيث نقدم طبيب عيون في كل عيادة سكر عن طريق التقنية الحديثة.</div>
					</v-col>
				</v-row>
			</v-container>
		</v-card>

		<v-card class="grey lighten-5 py-6" tile flat>
			<v-container>
				<v-row no-gutters>
					<v-col cols="12">
						<div class="headline primary--text font-weight-black">
							<v-icon color="primary" right size="30">mdi-format-list-bulleted-square</v-icon>ماذا نقدم؟
						</div>
					</v-col>
					<v-col cols="12" class="subtitle-1">
						<v-timeline dense>
							<v-timeline-item class="pb-2" small>
								<span>نقدم حلول الكشف المبكر عن اعتلال الشبكية السكري.</span>
							</v-timeline-item>
							<v-timeline-item class="pb-2" small>
								<span>دراسة المنطقة المعنية بالفحص لمعرفة حجم المشكلة وتقرير الإمكانات اللازمة لعمل المسح الفعال.</span>
							</v-timeline-item>
							<v-timeline-item class="pb-2" small>
								<span>توفير الكاميرات وربطها بمنصة (تلي رتنا) والتي تقدم خدمات حفظ واسترجاع الصور والتقارير وإدارة المرضى من خلال رسائل تذكير المواعيد وجدولة الفحص الدوري.</span>
							</v-timeline-item>
							<v-timeline-item class="pb-2" small>
								<span>بالإضافة الى قراءة صور الشبكية لاكتشاف مدى تأثرها من السكر نقوم بفحص الشبكية والعصب البصري لاكتشاف أمراض أخرى مثل: تأثر العصب المصاحب للماء الأزرق واعتلال الشبكية المصاحب لتقدم العمر.</span>
							</v-timeline-item>
							<v-timeline-item class="pb-2" small>
								<span>إمكانية إدخال الذكاء الصناعي كمساعد لقراءة الصور.</span>
							</v-timeline-item>
							<v-timeline-item class="pb-2" small>
								<span>كما نقدم خدمة إصدار الإحصاءات عن نتائج برنامج الكشف المبكر لاعتلال الشبكية ومدى فاعليته في تغطية الفئة المستهدفة.</span>
							</v-timeline-item>
						</v-timeline>
					</v-col>
				</v-row>
			</v-container>
		</v-card>

		<v-card class="grey lighten-4 py-6" tile flat>
			<v-container>
				<v-row no-gutters>
					<v-col cols="12">
						<div class="headline primary--text font-weight-black">
							<v-icon color="primary" right size="30">mdi-star</v-icon>المميزات
						</div>
					</v-col>
					<v-col cols="12" class="subtitle-1">
						<div class="primary--text headline pt-4 pb-0">للمرضى:</div>

						<v-timeline dense>
							<v-timeline-item class="pb-2" icon="mdi-numeric-1">
								<span>توفر على المريض الذهاب لطبيب العيون وقائمة الانتظار للحصول على موعد.</span>
							</v-timeline-item>
							<v-timeline-item class="pb-2" icon="mdi-numeric-2">
								<span>تقليل مدة فحص العيون من خلال عمل الفحص في نفس زيارة المريض لعيادة السكر او المركز الصحي القريب منه.</span>
							</v-timeline-item>
							<v-timeline-item class="pb-2" icon="mdi-numeric-3">
								<span>التأكد من عمل الفحص الدوري السنوي لمرضى السكر من خلال معرفة مدى التغطية وتحسن التزام المرضى بالفحص الدوري.</span>
							</v-timeline-item>
							<v-timeline-item class="pb-2" icon="mdi-numeric-4">
								<span>منع العمى بكشف اعتلال الشبكية السكري في مراحله المبكرة والتأكد من إحالة المرضى المحتاجين إلى علاج إلى متخصصين في الوقت المناسب.</span>
							</v-timeline-item>
						</v-timeline>
					</v-col>

					<v-col cols="12" class="subtitle-1">
						<div class="primary--text headline pt-4 pb-0">للمراكز الطبية:</div>

						<v-timeline dense>
							<v-timeline-item class="pb-2" icon="mdi-numeric-1">
								<span>إضافة خدمة لمرضى السكر وزيادة عدد المرضى بدل تحويلهم الى طبيب العيون.</span>
							</v-timeline-item>
							<v-timeline-item class="pb-2" icon="mdi-numeric-2">
								<span>تحسين رعاية مرضى السكري من خلال تحديد المرضى الذين يعانون من العلامات المبكرة لاعتلال شبكية العين السكر حيث يتسنى لطبيب الرعاية الاولية من تكثيف متابعة المريض.</span>
							</v-timeline-item>
						</v-timeline>
					</v-col>
				</v-row>
			</v-container>
		</v-card>

		<v-card class="grey lighten-5 py-6" tile flat>
			<v-container>
				<v-row no-gutters>
					<v-col cols="12">
						<div class="headline primary--text font-weight-black">
							<v-icon color="primary" right size="30">mdi-alpha-t-circle</v-icon>تلي رتنا:
						</div>
					</v-col>
					<v-col cols="12" class="subtitle-1 pt-6 pb-6">
						<template>هي عبارة عن منصة مصممة لتكون بمثابة نظام لإدارة بيانات المرضى الذي يمكن أن يتكامل مع كاميرات الشبكية لإرسال الصور إلى مركز القراءة وأرشفة تقارير التشخيص. كما أنه يقدم خدمة المتابعة والتذكير بمواعيد الفحوصات الدورية.</template>
					</v-col>

					<v-col cols="12">
						<div class="headline primary--text font-weight-black">
							<v-icon color="primary" right size="30">mdi-notebook-multiple</v-icon>مركز القراءة:
						</div>
					</v-col>
					<v-col cols="12" class="subtitle-1 pt-6 pb-6">
						<template>توفر المنصة خدمات قراءة صور الشبكية للكشف عن اعتلال الشبكية من خلال أطباء العيون المختصين. بمساعدة نظام الذكاء الاصطناعي و الذي اثبت نجاحا ملحوظا في اجراء الفحص الدوري.</template>
					</v-col>

					<v-col cols="12">
						<div class="headline primary--text font-weight-black">
							<v-icon color="primary" right size="30">mdi-brain</v-icon>الذكاء الاصطناعي :
						</div>
					</v-col>
					<v-col cols="12" class="subtitle-1 pt-6 pb-6">
						<template>تعمل تلي رتنا بالشراكة مع الشركة الامريكية ( اينوك ) لتفعيل استخدام برنامج فحص اعتلال الشبكية بتقنية الذكاء الاصطناعي و الذي اثبت فاعليته في الدراسات المحكمة.</template>
					</v-col>
				</v-row>
			</v-container>
		</v-card>

		<v-card class="grey lighten-4 py-6" tile flat>
			<v-container>
				<v-row no-gutters>
					<v-col cols="12">
						<div class="headline primary--text font-weight-black">
							<v-icon color="primary" right size="30">mdi-account-group</v-icon>فريق تلي رتنا:
						</div>
					</v-col>
					<v-col cols="12" class="subtitle-1 pt-6">
						<v-container class="pa-0">
							<v-row dense>
								<v-col v-for="member in team" :key="member.id" cols="12" sm="6" md="4">
									<v-card outlined style="height: 100%">
										<v-card-text class="secondary--text">
											<strong class="primary--text title">{{ member.name }}</strong>
											<br />
											{{ member.job }}
											<br />
											{{ member.role }}
										</v-card-text>
									</v-card>
								</v-col>
							</v-row>
						</v-container>
					</v-col>
				</v-row>
			</v-container>
		</v-card>

		<v-card class="grey lighten-5 py-6" tile flat>
			<v-container>
				<v-row no-gutters>
					<v-col cols="12">
						<div class="headline primary--text font-weight-black">
							<v-icon color="primary" right size="30">mdi-trophy-variant</v-icon>إنجازاتنا:
						</div>
					</v-col>
					<v-col cols="12" class="subtitle-1">
						<v-timeline dense>
							<v-timeline-item class="pb-2" small>
								<span>تكوين فريق يحمل رؤية واضحة للإنجاز .</span>
							</v-timeline-item>
							<v-timeline-item class="pb-2" small>
								<span>الانضمام الى مسرعة الاعمال في القطاع الصحي.</span>
							</v-timeline-item>
							<v-timeline-item class="pb-2" small>
								<span>القبول في حاضنة التقنية الحيوية بادر.</span>
							</v-timeline-item>
							<v-timeline-item class="pb-2" small>
								<span>المراحل الأخيرة من تطوير منصة تلي رتنا</span>
							</v-timeline-item>
							<v-timeline-item class="pb-2" small>
								<span>عقد شراكات في مجال الذكاء الاصطناعي.</span>
							</v-timeline-item>
						</v-timeline>
					</v-col>
				</v-row>
			</v-container>
		</v-card>
	</div>
</template>

<script>
export default {
	mixins: [
		require("@/mixins/router-mixin").default,
		require("@/mixins/permissions-mixin").default
	],
	data: () => ({
		headline: "Teleretina: Fight Diabetic Blindness",
		welcome: "Welcome to",
		tele: "Tele",
		retina: "Retina",
		about_us: "About Us",
		vision: "Vision",
		message: "Message",
		goals: "Goals",
		target: "Our Target",
		slogan: "Fight Diabetic Blindness",
		team: [
			{
				id: 1,
				name: "الدكتورة: الاء حسن السلمان",
				job: "إدارة صحية دبلوم و طبيبة اسنان",
				role: "المدير التنفيذي"
			},
			{
				id: 2,
				name: "الدكتور: عبدالاله عبدالعزيز العبدالله ",
				job: "استشاري عيون تخصص الشبكية",
				role: "الإدارة الطبية"
			},
			{
				id: 3,
				name: "المهندس: عصام علي المطير",
				job: "ماجستير تقنية معلومات",
				role: "الإدارة التقنية"
			},
			{
				id: 4,
				name: "المهندس: حسن علي الخميس",
				job: "مطور برامج في معهد الإدارة",
				role: "مطور برامج"
			},
			{
				id: 5,
				name: "المطور: محمد صادق الجريش",
				job: "بكالوريوس علوم الحاسب الآلي",
				role: "تحليل نظم"
			},
			{
				id: 6,
				name: "المطور: ابراهيم عبدالوهاب البلادي",
				job: "بكالوريوس علوم الحاسب الآلي",
				role: "مطور واجهات"
			}
		]
	}),
	computed: {
		arabic() {
			return this.$store.state.arabic;
		}
	},
	watch: {
		arabic: {
			handler: function(newVal) {
				if (newVal) {
					this.$vuetify.rtl = true;
					this.headline = "تليريتنا: حيث القضاء على العمى السكري";
					this.welcome = "اهلا بك في";
					this.tele = "تيلي";
					this.retina = "ريتنا";
					this.about_us = "عنا";
					this.vision = "الرؤية";
					this.message = "الرسالة";
					this.goals = "الاهداف";
					this.target = "الطموح";
					this.slogan = "حيث القضاء على العمى السكري";
				} else {
					this.$vuetify.rtl = false;
					this.headline = "Teleretina: Fight Diabetic Blindness";
					this.welcome = "Welcome to";
					this.tele = "Tele";
					this.retina = "Retina";
					this.about_us = "About Us";
					this.vision = "Vision";
					this.message = "Message";
					this.goals = "Goals";
					this.target = "Our Target";
					this.slogan = "Fight Diabetic Blindness";
				}
			},
			immediate: true
		}
	},
	mounted() {
		if (this.arabic) {
			this.$vuetify.rtl = true;
			this.headline = "تليريتنا: حيث القضاء على العمى السكري";
			this.welcome = "اهلا بك في";
			this.tele = "تيلي";
			this.retina = "ريتنا";
			this.about_us = "عنا";
			this.vision = "الرؤية";
			this.message = "الرسالة";
			this.goals = "الاهداف";
			this.target = "الطموح";
			this.slogan = "حيث القضاء على العمى السكري";
		}
	},
	methods: {
		openContactUs() {
			document.getElementById("contactUsButton").click();
		}
	}
};
</script>

<style>
.round {
	border-radius: 15px;
}

.primary--text .v-label {
	color: inherit;
}

.v-timeline:before {
	content: initial;
}

ul.no-list {
	list-style-type: none;
}

ul {
	margin-top: 4px;
	margin-bottom: 8px;
}

.v-application--is-rtl ol,
.v-application--is-rtl ul {
	padding-left: 0;
	padding-right: 24px;
}

.rotating {
	transform: rotate(360deg);
	transition: 5000ms;
}

.scaling {
	transform: scale(2);
	transition: 5000ms;
}

.flip-card-inner {
	position: relative;
	width: 100%;
	height: 100%;
	text-align: center;
	transition: transform 0.8s;
	transform-style: preserve-3d;
}

.flip-card:hover .flip-card-inner {
	transform: rotateY(180deg);
}

.flip-card-front,
.flip-card-back {
	position: absolute;
	width: 100%;
	height: 100%;
	backface-visibility: hidden;
}

.flip-card-front {
	position: relative;
}

.flip-card-back {
	transform: rotateY(180deg);
}

div,
span {
	transition: color 500ms;
}

.v-timeline-item__divider {
	min-width: 56px;
}

.v-timeline--dense .v-timeline-item__body {
	max-width: 100%;
	min-height: 38px;
}

.v-timeline--dense .v-timeline-item__body span {
	vertical-align: text-top;
	line-height: 1.5;
}
</style>